module.exports = __webpack_public_path__ + "static/media/client-advocate.1d8daa3f.png";